import { Modal } from '@material-ui/core';
import ScrollContainer from 'react-indiana-drag-scroll';
import Skeleton from 'react-loading-skeleton-2';
import SwipeableViews from 'react-swipeable-views';
import { TransitionGroup } from 'react-transition-group';
import styled, { css } from 'styled-components';
import PrimitiveModal from '../../newComponents/Modal';

export const Container = styled.div<{
  asideIsOpen?: boolean;
  asideIsClosed?: boolean;
}>`
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  width: 100%;
  max-width: 100%;
  min-height: calc(100% - 64px);
  max-height: calc(100% - 64px);
  font-family: Sora, sans-serif;
  height: 100%;

  h1 {
    font-size: 28px;
    font-weight: 700;
    color: var(--color-navy-blue);
    line-height: 35px;

    span {
      font-weight: 400;
    }
  }

  main {
    max-height: calc(100vh - 64px);
    display: flex;
    flex-direction: column;
    flex: 2;
    overflow: hidden;

    .header {
      padding: 24px 24px 0px;

      @media (min-width: 768px) {
        padding: 30px 30px 0px;
      }

      > p {
        font-weight: 400;
        color: var(--color-alba-grandeza);
        margin-bottom: 30px;

        strong {
          color: var(--color-navy-blue);
          font-weight: 600;
        }
      }
    }
  }

  @media (min-width: 600px) {
    ${(props) =>
      !props.asideIsOpen &&
      css`
        > aside {
          display: flex !important;

          .prev {
            display: none !important;
          }
        }

        > main {
          display: flex !important;

          .cart {
            display: none !important;
          }
      `}
    }
  }

  @media (min-width: 900px) {
    > aside {
      display: flex !important;

      .prev {
        display: none !important;
      }
    }

    > main {
      display: flex !important;

      .cart {
        display: none !important;
      }
    }
  }

  ${(props) =>
    props.asideIsClosed &&
    css`
      > aside {
        display: none;
      }

      > main {
        display: flex;
      }
    `}

  ${(props) =>
    !props.asideIsClosed &&
    css`
      > aside {
        max-width: 100%;
      }

      > main {
        display: none;
      }
    `}
`;

export const CustomScrollContainer = styled(ScrollContainer)`
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  gap: 10px;
  margin: 15px 0px 20px;
  max-width: 100%;
  flex: none;
`;

export const ContainerProductItems = styled(TransitionGroup)`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 20px;
  overflow-y: auto;

  scrollbar-width: thin;
  scrollbar-color: black transparent;

  &::-webkit-scrollbar {
    width: 3px;
    height: 3px;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
    padding: 2px;
  }

  &::-webkit-scrollbar-thumb {
    background-color: #a1a1a1;
  }

  > div {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 182px;
    height: auto;
    border-radius: 5px;
    border: 2px solid var(--color-gray-900);
    cursor: pointer;

    :hover {
      border-color: var(--color-blue);
    }

    > div {
      width: 100%;
      height: 100%;
      padding: 10px 15px 20px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      gap: 10px;
      text-align: center;

      p,
      span {
        font-size: 15px;
        line-height: 19px;
        color: var(--color-navy-blue);
      }

      p:last-child {
        font-weight: 600;
        font-size: 14px;
        line-height: 18px;
      }
    }
  }

  img {
    width: 100%;
    height: 122px;
    object-position: center;
    object-fit: cover;
  }
`;

export const ContainerItemSelectable = styled.div<{ seleted?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px;
  border: 2px solid var(--color-gray-900);
  ${(p) =>
    p.seleted &&
    css`
      border-color: var(--color-blue);
    `}
  border-radius: 5px;
  height: fit-content;

  :hover {
    border-color: var(--color-blue);
    cursor: pointer;

    p {
      color: var(--color-navy-blue);
    }
  }

  p {
    user-select: none;
    font-size: 11px;
    line-height: 14px;
    white-space: nowrap;
    color: var(--color-gray-800);
    ${(p) =>
      p.seleted &&
      css`
        color: var(--color-navy-blue);
      `}
  }
`;

export const ModalHeader = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  div {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 80px;
    height: 80px;
    border-radius: 50%;
    background-color: rgba(246, 68, 68, 0.2);
    margin: none;
    svg {
      color: #f64444;
      font-size: 50px;
    }
  }
  h1 {
    color: #101d40;
    font-size: 24px;
    text-align: center;
    font-weight: 800;
    margin-top: 15px;
    font-family: 'Sora', sans-serif;
  }
  button {
    position: absolute;
    top: 10px;
    right: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    border: none;
    width: 24px;
    height: 24px;
    border-radius: 50%;
    background-color: rgba(215, 222, 233, 0.25);
    svg {
      color: #4f4f4f;
      font-size: 22px;
    }
    &:hover {
      background-color: rgba(215, 222, 233, 0.5);
    }
  }
`;

export const ContainerCoupon = styled.div<{ selectedCoupon?: boolean }>`
  display: flex;
  border: 2px solid var(--color-gray-900);
  justify-content: space-between;
  padding: 12px;
  align-items: center;
  border-radius: 5px;
  ${(p) =>
    p.selectedCoupon &&
    css`
      background-color: #329bfc1a;
      border-color: var(--color-blue);
    `}

  p {
    font-size: 13px;
  }

  button {
    font-size: 11px;
    font-weight: 400;
    padding: 11px;
    height: 36px;
  }

  button.remove {
    background-color: var(--color-red);

    :hover {
      background-color: var(--color-red);
    }
  }
`;

export const CustomModal = styled(Modal)`
  display: flex;
  justify-content: center;
  align-items: center;

  > div.body {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    width: fit-content;
    padding: 20px;
    height: fit-content;
    background: #fff;
    border-radius: 4px;
    position: relative;
    gap: 8px;
    max-width: 350px;
    max-height: 90vh;

    form {
      display: flex;
      flex-direction: column;
      gap: 16px;
      max-height: 50vh;
      overflow: auto;
      min-height: 200px;
      width: 100%;

      scrollbar-width: thin;
      scrollbar-color: black transparent;

      &::-webkit-scrollbar {
        width: 3px;
        height: 3px;
      }

      &::-webkit-scrollbar-track {
        background: transparent;
        padding: 2px;
      }

      &::-webkit-scrollbar-thumb {
        background-color: #a1a1a1;
      }
    }
  }
`;

export const CustomSwipeableViews = styled(SwipeableViews)`
  max-height: calc(100vh - 64px);
`;

export const CustomSkeletonItemGroup = styled(Skeleton)`
  height: 42px;
  width: 80px;
  min-width: 80px;
`;

export const CustomSkeletonItemProduct = styled(Skeleton)`
  min-height: 222px;
  height: 222px;
  width: 182px;
  min-width: 182px;
`;

export const CustomModalV2 = styled(PrimitiveModal)`
  gap: 10px;
  position: relative;
  padding: 28px 32px;
  border-radius: 8px;
  max-width: 400px;
  font-family: 'Sora', sans-serif;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  p {
    text-align: center;
    font-family: 'Sora', sans-serif;
    font-size: 14px;
    color: #7c8db5;
    margin-bottom: 10px;

    strong {
      color: #101d40;
      font-weight: 600;
      margin-top: 5px;
    }
  }
`;
